import { Tent } from 'lucide-react'
import { fmtTime, fmtEuroInt } from '../lib/format'

const TROEDEL = 'var(--accent-troedel)'

// Live-Zustand: laufende Trödel-Session. Tap → direkt in die Live-Markt-Ansicht.
// "Verkauf erfassen"-Button bewusst weggelassen (Tap auf Card navigiert).
export function LiveMarktCard({ session, onOpenLive }) {
  const { location, starts_at, todayRevenue, salesCount } = session
  const since = starts_at ? fmtTime(starts_at) : null

  return (
    <div
      onClick={onOpenLive}
      role="button"
      className="cursor-pointer rounded-[20px] bg-[var(--bg-L1)] p-4 active:scale-[0.99]"
      style={{ transition: 'transform 100ms var(--ease-out-ios)' }}
    >
      {/* Live-Status (Sentence-Case, Farbe = Bedeutung) */}
      <div className="mb-3 flex items-center gap-1.5 text-[13px]">
        <span className="bl-pulse" style={{ background: 'var(--accent-stand)' }} />
        <span className="font-semibold" style={{ color: 'var(--accent-stand)' }}>Markt läuft</span>
        {since && <span className="text-[var(--label-secondary)]">· seit {since}</span>}
      </div>

      {/* Name-Row */}
      <div className="mb-3 flex items-center gap-3">
        <div
          className="w-11 h-11 rounded-[13px] flex items-center justify-center flex-shrink-0"
          style={{ background: 'var(--tint-troedel)' }}
        >
          <Tent size={23} style={{ color: TROEDEL }} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="truncate text-[17px] font-semibold">{location || 'Markttag'}</div>
          {salesCount != null && (
            <div className="mt-px text-[13px] text-[var(--label-secondary)]">
              {salesCount} {salesCount === 1 ? 'Verkauf' : 'Verkäufe'} heute
            </div>
          )}
        </div>
      </div>

      {/* Heute-Umsatz + Sprung in den Live-Markt */}
      <div className="flex items-end justify-between border-t border-[var(--separator)] pt-3">
        <div>
          <div className="text-[13px] text-[var(--label-secondary)]">Heute</div>
          <div className="num text-[28px] font-bold leading-tight">{fmtEuroInt(todayRevenue)}</div>
        </div>
        <span className="flex h-11 items-center gap-1 rounded-full bg-[var(--tint-troedel)] px-4 text-[15px] font-semibold" style={{ color: TROEDEL }}>
          Zum Live-Markt
        </span>
      </div>
    </div>
  )
}
